import axios from 'axios'
import axiosRetry from 'axios-retry'

const client = axios.create({
  baseURL: process.env.BASE_API,
  headers: {
    'content-type': 'application/json',
  },
})

axiosRetry(client)

export default client
